// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610141514/js/" + chunkId + "." + {"44":"436f2f55","225":"84c18eb5","481":"c4381a1f","486":"fe39d8de","770":"56c703f7"}[chunkId] + ".0.9956202587592675.chunk.js";
};